/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningspayoutreview2Inputs */

const en_earningspayoutreview2 = /** @type {(inputs: Earningspayoutreview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe is still checking`)
};

const de_earningspayoutreview2 = /** @type {(inputs: Earningspayoutreview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe prüft noch`)
};

/**
* | output |
* | --- |
* | "Stripe is still checking" |
*
* @param {Earningspayoutreview2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningspayoutreview2 = /** @type {((inputs?: Earningspayoutreview2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningspayoutreview2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningspayoutreview2(inputs)
	return de_earningspayoutreview2(inputs)
});
export { earningspayoutreview2 as "earningsPayoutReview" }